import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  holidays: [], // Initial holidays array
};

const holidaySlice = createSlice({
  name: 'holidays',
  initialState,
  reducers: {
    setHolidays: (state, action) => {
      state.holidays = action.payload;
    },
    addHoliday: (state, action) => {
      state.holidays.push(action.payload);
    },
    updateHoliday: (state, action) => {
      const updatedHoliday = action.payload;
      state.holidays = state.holidays.map((holiday) =>
        holiday.id === updatedHoliday.id ? updatedHoliday : holiday
      );
    },
    deleteHoliday: (state, action) => {
      const holidayIndex = state.holidays.findIndex((holiday) => holiday.id === action.payload);
      if (holidayIndex !== -1) {
        state.holidays.splice(holidayIndex, 1);
      }
    },
  },
});

export const { setHolidays, addHoliday, updateHoliday, deleteHoliday } = holidaySlice.actions;

export default holidaySlice.reducer;
